<template>
    <div >
        <div class=" py-2 pl-2 flex incorporated items-center gap-4">
            <img src="../../../../../../../../../../../../../src/assets/images/settings/clue icon.svg" alt="" srcset="">
            <p class="text-[14px] font-bold text-[#383F51]">Upload a JPG, JPEG, PNG, or PDF file only.</p>
        </div> 
        <form class="mt-4">
            <div class="flex gap-6">
                <div class="flex-1 ">
                    <label for="">Registered Name</label>
                    <input type="text" placeholder="Enter" v-model="kyc.incorporationName">
                </div>
                <div class="flex-1 ">
                    <label for="">RC Number</label>
                    <input type="text" placeholder="Enter" v-model="kyc.rcNumber">
                </div>
                <div class="flex-1 ">
                    
                    <label for="">Certificate of Registration</label>
                   <input ref="fileInput" type="file" style="display: none;" accept="image/*" @change="onFileSelected" >
                        <button v-if="!imageUrl.certificateOfIncorporation" @click.prevent="selectImage('certificateOfIncorporation')" class="flex justify-between items-center">
                            <p class="text-[14px] font-normal text-[#7A90A7]">Upload File </p>
                            <img src="../../../../../../../../../../../../assets/images/ondemand/upload-icon-claim.svg" alt="" srcset="">
                        </button>
                    <button  v-if="imageUrl.certificateOfIncorporation" class=" flex justify-between items-center">
                            <img width="" src="../../../../../../../../../../../../assets/images/ondemand/uploaded-file-icon.svg" alt="Selected Image"  />
                            <p class="text-[14px] font-normal text-[#383F51]">{{ kyc.certificateOfIncorporation }}</p>
                            <img @click.prevent="removeImage(imageUrl.certificateOfIncorporation, 'certificateOfIncorporation')"  src="../../../../../../../../../../../../assets/images/ondemand/claim-icon-close.svg" alt="" srcset="">
                    </button>
                </div>
            </div>  
            <div class="flex gap-6 mt-4 mb-4">
                <div class="flex-1 ">
                    <label for="">Certified Extract of Registration Information</label>
                      <input ref="fileInput" type="file" style="display: none;" accept="image/*" @change="onFileSelected" >
                        <button v-if="!imageUrl.memat" @click.prevent="selectImage('memat')" class="flex justify-between items-center">
                            <p class="text-[14px] font-normal text-[#7A90A7]">Upload File </p>
                            <img src="../../../../../../../../../../../../assets/images/ondemand/upload-icon-claim.svg" alt="" srcset="">
                        </button>
                    <button  v-if="imageUrl.memat" class=" flex justify-between items-center">
                            <img width="" src="../../../../../../../../../../../../assets/images/ondemand/uploaded-file-icon.svg" alt="Selected Image"  />
                            <p class="text-[14px] font-normal text-[#383F51]">{{ kyc.memat }}</p>
                            <img @click.prevent="removeImage(imageUrl.memat, 'memat')"  src="../../../../../../../../../../../../assets/images/ondemand/claim-icon-close.svg" alt="" srcset="">
                    </button>
                </div>
                <div class="flex-1 ">
                    <label for="">Tax Identification Number</label>
                    <input type="text" placeholder="Enter" v-model="kyc.tin">
                </div>
                <div class="flex-1 ">
                    <label for="">Tax Identification Document (Optional)</label>
                     <input ref="fileInput" type="file" style="display: none;" accept="image/*" @change="onFileSelected" >
                        <button v-if="!imageUrl.tid" @click.prevent="selectImage('tid')" class="flex justify-between items-center">
                            <p class="text-[14px] font-normal text-[#7A90A7]">Upload File </p>
                            <img src="../../../../../../../../../../../../assets/images/ondemand/upload-icon-claim.svg" alt="" srcset="">
                        </button>
                    <button  v-if="imageUrl.tid" class=" flex justify-between items-center">
                            <img width="" src="../../../../../../../../../../../../assets/images/ondemand/uploaded-file-icon.svg" alt="Selected Image"  />
                            <p class="text-[14px] font-normal text-[#383F51]">{{ kyc.tid }}</p>
                            <img @click.prevent="removeImage(imageUrl.tid, 'tid')"  src="../../../../../../../../../../../../assets/images/ondemand/claim-icon-close.svg" alt="" srcset="">
                    </button>
                </div>
            </div>
            <div class="flex gap-6">
                <div class="flex-1 ">
                    <label for="">Regulatory License (NIPOST)</label>
                      <input ref="fileInput" type="file" style="display: none;" accept="image/*" @change="onFileSelected" >
                        <button v-if="!imageUrl.regulatoryLicense" @click.prevent="selectImage('regulatoryLicense')" class="flex justify-between items-center">
                            <p class="text-[14px] font-normal text-[#7A90A7]">Upload File </p>
                            <img src="../../../../../../../../../../../../assets/images/ondemand/upload-icon-claim.svg" alt="" srcset="">
                        </button>
                    <button  v-if="imageUrl.regulatoryLicense" class=" flex justify-between items-center">
                            <!-- <img :src="imageUrl" alt="Selected Image" width="300" /> -->
                            <img width="" src="../../../../../../../../../../../../assets/images/ondemand/uploaded-file-icon.svg" alt="Selected Image"  />
                            <p class="text-[14px] font-normal text-[#383F51]">{{ kyc.regulatoryLicense }}</p>
                            <img @click.prevent="removeImage(imageUrl.regulatoryLicense, 'regulatoryLicense')"  src="../../../../../../../../../../../../assets/images/ondemand/claim-icon-close.svg" alt="" srcset="">
                    </button>
                </div>
                <div class="flex-1 ">
                    
                </div>
                <div class="flex-1 ">
                    
                </div>
            </div>
            <div class="next-submit flex justify-end mt-4">
                <button @click.prevent="" class="py-2 px-4 text-[16px] font-semibold text-[#10233E] ">Next</button>
            </div>
        </form>    
    </div>
</template>

<script>
// import PhoneInput from '@/components/UI/TelInput/PhoneInput.vue';
// import TelCustomInput from '@/components/UI/TelInput/TelCustomInput.vue';

export default {
//   components: { PhoneInput },

  data() {
    return {
        fileType: '',
        imageUrl: {
            incorporationName: null,
            rcNumber: null,
            certificateOfIncorporation: null,
            memat: null,
            formCAC: null,
            statusReport: null,
            regulatoryLicense: null,
            tid: null
        },
      kyc: {
        incorporationName: '',
        rcNumber: "",
        certificateOfIncorporation: '',
        memat: "",
        formCAC: "",
        statusReport: "",
        regulatoryLicense: "",
        tin: "",
        tid: ''
      },
    };
  },
  methods: {
    selectImage(fileType) {
      this.$refs.fileInput.click();
      this.fileType = fileType
    },
    onFileSelected(event) {
      const file = event.target.files[0];
      if (this.fileType === 'certificateOfIncorporation' && file && file.type.startsWith('image/')) {
        this.kyc.certificateOfIncorporation = file.name;
        this.imageUrl.certificateOfIncorporation = URL.createObjectURL(file);
         this.$forceUpdate(); 
      }else if (this.fileType === 'memat' && file && file.type.startsWith('image/')) {
        this.kyc.memat = file.name;
        this.imageUrl.memat = URL.createObjectURL(file);
         this.$forceUpdate();
      }else if (this.fileType === 'formCAC' && file && file.type.startsWith('image/')) {
        this.kyc.formCAC = file.name;
        this.imageUrl.formCAC = URL.createObjectURL(file);
         this.$forceUpdate();
      }else if (this.fileType === 'statusReport' && file && file.type.startsWith('image/')) {
        this.kyc.statusReport = file.name;
        this.imageUrl.statusReport = URL.createObjectURL(file);
         this.$forceUpdate();
      }else if (this.fileType === 'regulatoryLicense' && file && file.type.startsWith('image/')) {
        this.kyc.regulatoryLicense = file.name;
        this.imageUrl.regulatoryLicense = URL.createObjectURL(file);
         this.$forceUpdate();
      }else if (this.fileType === 'tid' && file && file.type.startsWith('image/')) {
        this.kyc.tid = file.name;
        this.imageUrl.tid = URL.createObjectURL(file);
         this.$forceUpdate();
      }else {
        this.generateToast("Please select a valid image file!", "error");
        this.imageUrl = null;  
      }
      
    },
    removeImage(file, fileType) {
        this.fileType = fileType
    if ( file === this.imageUrl.certificateOfIncorporation && this.fileType === 'certificateOfIncorporation'){
        this.imageUrl.certificateOfIncorporation = null
        this.$refs.fileInput.value = ''; 
      this.$forceUpdate(); 
    }else if ( file === this.imageUrl.memat && this.fileType === 'memat'){
        this.imageUrl.memat = null
        this.$refs.fileInput.value = ''; 
      this.$forceUpdate(); 
    }else if ( file === this.imageUrl.formCAC && this.fileType === 'formCAC'){
        this.imageUrl.formCAC = null
        this.$refs.fileInput.value = ''; 
      this.$forceUpdate(); 
    }else if ( file === this.imageUrl.statusReport && this.fileType === 'statusReport'){
        this.imageUrl.statusReport = null
        this.$refs.fileInput.value = ''; 
      this.$forceUpdate(); 
    }else if ( file === this.imageUrl.regulatoryLicense && this.fileType === 'regulatoryLicense'){
        this.imageUrl.regulatoryLicense = null
        this.$refs.fileInput.value = ''; 
      this.$forceUpdate(); 
    }else if ( file === this.imageUrl.tid && this.fileType === 'tid'){
        this.imageUrl.tid = null
        this.$refs.fileInput.value = ''; 
      this.$forceUpdate(); 
    }
    },
  }
  
}
</script>

<style scoped>
.incorporated {
border-radius: 8px;
background-color: #F2F7FC;
}

/* form>:nth-child(1)>div,form>:nth-child(2)>div,form>:nth-child(3)>div{
   
    input{
        width: 100%;
        
    }
} */
label{
    font-weight: 700;
    font-size: 14px;
    color: #383F51;
}
input{
    background-color: #FBFCFE;
    border: 1px solid #DAE8F6;
    border-radius: 2px;
    padding: 2% 0 2% 2%;
    width: 100%;
}
.next-submit>button{
    background-color: #FCC210;
    border-radius: 2px;
}
form>:nth-child(1)>:nth-child(3)>button,
form>:nth-child(2)>:nth-child(3)>button,
form>:nth-child(2)>:nth-child(1)>button,
form>:nth-child(3)>:nth-child(1)>button{
    background-color: #FBFCFE;
    border: 1px solid #DAE8F6;
    border-radius: 2px;
    padding: 2% 2% 2% 2%;
    width: 100%;
}
</style>
